import React from 'react';
import { PencilSimple } from 'phosphor-react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import './SAvatar.css';

export interface SAvatarProps {
  variant: 'sm' | 'profile';
  editable?: boolean;
  onEditClick?: () => void;
  avatarUrl?: string;
}

export const SAvatar: React.FC<SAvatarProps> = ({
  variant,
  editable = false,
  onEditClick,
  avatarUrl,
}) => {
  // Get user data from Redux
  const user = useSelector((state: RootState) => state.auth.user);

  // Get user initials
  const getInitials = (): string => {
    if (!user) {
      return 'TB'; // Fallback initials
    }
    
    const firstInitial = user.firstName?.charAt(0).toUpperCase() || '';
    const lastInitial = user.lastName?.charAt(0).toUpperCase() || '';
    
    const initials = `${firstInitial}${lastInitial}`;
    
    return initials || 'TB'; // Fallback if both are empty
  };

  const initials = getInitials();
  const hasAvatar = !!(avatarUrl || user?.avatar);

  return (
    <div className="s-avatar-container">
      <div
        className={`s-avatar s-avatar--${variant}`}
        style={
          hasAvatar
            ? { backgroundImage: `url(${avatarUrl || user?.avatar})` }
            : { background: 'var(--TBX-Extra-Profile, linear-gradient(180deg, #787878 0%, #4E4E4E 100%))' }
        }
      >
        {!hasAvatar && <span className="s-avatar-initials">{initials}</span>}
      </div>

      {editable && variant === 'profile' && (
        <button
          className="s-avatar-edit-button"
          onClick={onEditClick}
          type="button"
          aria-label="Edit avatar"
        >
          <PencilSimple size={20} color="#111215" />
        </button>
      )}
    </div>
  );
};

export default SAvatar;
